import React from "react";
import { TRIP_STATUS } from "../../../../../Trips/Data/TripConstants";
import ClockIcon from "../../../../../../Common/Svgs/ClockIcon";
import { TickWithBgIcon } from "../../../../../../Common/Svgs/TickIcon";
import { SESSION_STATUS } from "../../../../../Sessions/constants";
import { TIME_OFF_STATUS } from "./constants";
import { CloseWithCircleIcon } from "../../../../../../Common/Svgs/CloseIcon";

const getScheduleStatus = ({ type = "", status = 0 }) => {
  if (!type || !status) return "";

  if (type === "trip") {
    switch (status) {
      case TRIP_STATUS.UPCOMING:
        return (
          <div className="bg-[#FCFCFC] max-w-max py-1.5 px-2 flex items-center gap-x-2 rounded-md">
            <ClockIcon size={16} className="text-black" />
            <p className="font-poppins font-medium text-xs text-black leading-[100%]">
              Upcoming
            </p>
          </div>
        );

      case TRIP_STATUS.ONGOING:
        return (
          <div className="bg-green-20 max-w-max py-1.5 px-2 flex items-center gap-x-2 rounded-md">
            <ClockIcon size={16} className="text-green" />
            <p className="font-poppins font-medium text-xs text-green leading-[100%]">
              Ongoing
            </p>
          </div>
        );

      case TRIP_STATUS.COMPLETED:
        return (
          <div className="bg-green max-w-max py-1.5 px-2 flex items-center gap-x-2 rounded-md">
            <TickWithBgIcon
              size={16}
              className="text-[#FCFCFC]"
              tickColor="#085054"
            />
            <p className="font-poppins font-medium text-xs text-[#FCFCFC] leading-[100%]">
              Completed
            </p>
          </div>
        );

      default:
        return <div />;
    }
  }

  if (type === "session") {
    switch (status) {
      case SESSION_STATUS.UPCOMING:
        return (
          <div className="bg-[#FCFCFC] max-w-max py-1.5 px-2 flex items-center gap-x-2 rounded-md">
            <ClockIcon size={16} className="text-black" />
            <p className="font-poppins font-medium text-xs text-black leading-[100%]">
              Upcoming
            </p>
          </div>
        );

      case SESSION_STATUS.ONGOING:
        return (
          <div className="bg-[#FDE8A8] max-w-max py-1.5 px-2 flex items-center gap-x-2 rounded-md">
            <ClockIcon size={16} className="text-black" />
            <p className="font-poppins font-medium text-xs text-black leading-[100%]">
              Ongoing
            </p>
          </div>
        );

      case SESSION_STATUS.COMPLETED:
        return (
          <div className="bg-yellow max-w-max py-1.5 px-2 flex items-center gap-x-2 rounded-md">
            <TickWithBgIcon
              size={16}
              className="text-[#faD152]"
              tickColor="#000000"
              strokeColor="#000000"
            />
            <p className="font-poppins font-medium text-xs text-black leading-[100%]">
              Completed
            </p>
          </div>
        );

      default:
        return <div />;
    }
  }

  if (type === "timeoff") {
    switch (status) {
      case TIME_OFF_STATUS.PENDING:
        return (
          <div className="flex items-center gap-x-2 rounded-md">
            <ClockIcon size={16} fillColor="#C84630" className="text-white" />
            <p className="font-poppins font-medium text-xs text-alert-red leading-[100%]">
              Pending
            </p>
          </div>
        );

      case TIME_OFF_STATUS.APPROVED:
        return (
          <div className="flex items-center gap-x-2 rounded-md">
            <TickWithBgIcon
              size={16}
              className="text-green"
              tickColor="#FCFCFC"
            />

            <p className="font-poppins font-medium text-xs text-green leading-[100%]">
              Approved
            </p>
          </div>
        );

      case TIME_OFF_STATUS.REJECTED:
        return (
          <div className="flex items-center gap-x-2 rounded-md">
            <CloseWithCircleIcon
              size={20}
              fillColor="#C84630"
              className="text-white"
            />

            <p className="font-poppins font-medium text-xs text-alert-red leading-[100%]">
              Rejected
            </p>
          </div>
        );

      default:
        return <div />;
    }
  }

  return <div>getScheduleStatus</div>;
};

export default getScheduleStatus;
